import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  FilterCondition,
  FilterDTO,
  FilterOperator,
  TagsPerParkerReportParameterDTO,
} from '../../../../../base/models/models.swagger.generated';
import { ClientService } from '../../../../../base/services/client/client.service';
import { UntypedFormBuilder } from '@angular/forms';
import { TagsPerParkerReportService } from '../tags-per-parker-report.service';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { Router } from '@angular/router';
import { reportsRoute } from '../../../../../core/routing/route-names';
import { SaveOptions } from '../../../reports-footer/save-options';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { TagsFormComponent } from '../tags-form/tags-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-tags-report',
    templateUrl: './tags-report.component.html',
    styleUrls: ['./tags-report.component.scss'],
    imports: [
        TitleBarComponent,
        TagsFormComponent,
        GridModule,
        ReportsFooterComponent,
        TranslateModule
    ]
})
export class TagsReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public data: DataManager;
  public filterForm = this.fb.group({
    parkerId: [null],
    companyId: [null],
    searchText: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(public clientService: ClientService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private tagsPerParkerReportService: TagsPerParkerReportService) {
  }

  ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.tagsPerParkerReportService, this.spinnerService),
    });

    //Initially get all
    if (this.selectedClient) {
      this.searchReports();
    }
  }

  public searchReports(): void {
    const filters = [];
    if (this.filterForm.get('parkerId').value) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'ParkerId',
        operator: FilterOperator.Equal,
        value: this.filterForm.get('parkerId').value,
      }));
    }
    if (this.filterForm.get('companyId').value) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'Parker.CompanyId',
        operator: FilterOperator.Equal,
        value: this.filterForm.get('companyId').value,
      }));
    }
    if (this.filterForm.get('searchText').value) {
      filters.push(new FilterDTO({
        isComplex: true,
        condition: FilterCondition.Or,
        predicates: [
          new FilterDTO({
            isComplex: false,
            field: 'ControlPlateNumber',
            operator: FilterOperator.Contains,
            value: this.filterForm.get('searchText').value,
          }),
          new FilterDTO({
            isComplex: false,
            field: 'IdentificationCode',
            operator: FilterOperator.Contains,
            value: this.filterForm.get('searchText').value,
          }),
        ],
      }));
    }

    this.tagsPerParkerReportService.filters = filters;
    try {
      this.grid?.refresh();
    } catch (e) {
      // Ignore error when grid is in transition state
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();

    const tagsPerParkerReportParameterDTO = new TagsPerParkerReportParameterDTO({
      parkerId: this.filterForm.get('parkerId').value,
      companyId: this.filterForm.get('companyId').value,
      searchText: this.filterForm.get('searchText').value,
    });
    this.tagsPerParkerReportService.exportReport(tagsPerParkerReportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

}
